import formsManagerAPI from '../../config/api/formManagerAPI';
import * as R from 'ramda';
import { newField } from '../formFields/fields';
import { deleteForm } from '../forms/actions';
import {setDocumentTitle} from '../../config/documentTitle';
import { openDialog, closeDialog } from '../dialogs/actions';
import { dialogsList } from '../dialogs/constants';
import { findNextField, mergeNewComponent } from './utils';
import {formatFormSettingsData} from '../forms/utils';
import {
    EDITOR_GET_FORM,
    EDITOR_SELECT_FIELD,
    EDITOR_DELETE_FIELD,
    EDITOR_UPDATE_FIELD,
    EDITOR_ADD_FORM_FIELD,
    EDITOR_SAVE_FORM,
    EDITOR_DELETE_FORM,
    EDITOR_CLEAR_FORM,
    EDITOR_UPDATE_FORM_SETTINGS,
    EDITOR_REORDER_FIELDS,
    EDITOR_COPY_FIELD,
    EDITOR_CHANGE_FIELD_COMPONENT
} from './constants';

export const getForm = (urlFormId) => {
    return dispatch => {
        return formsManagerAPI.getForm(urlFormId)
            .then(({ data }) => {
                setDocumentTitle(`Editor [form: "${data.name}"]`);
                dispatch({
                    type: EDITOR_GET_FORM,
                    payload: data
                });
        });
    }
};

export const updateFormSettingsFromEditor = (formData, urlFormId) => {
    return (dispatch, getState) => {
        const { user: { profile: { organizations, userName } }, formEditor } = getState();
        let form = formatFormSettingsData(formData, formEditor.form, organizations, userName);
        return formsManagerAPI.saveFormSettings(form, urlFormId)
            .then(() => {
                dispatch({
                    type: EDITOR_UPDATE_FORM_SETTINGS,
                    payload: formData
                });
            });
    }
};

export const reorderFields = (jsonSchema) => ({
    type: EDITOR_REORDER_FIELDS,
    payload: jsonSchema
})

export const addFormField = (value) => {
    const newFormField = newField(value);
    return {
        type: EDITOR_ADD_FORM_FIELD,
        payload: newFormField
    };
};

export const selectField = (id) => ({
    type: EDITOR_SELECT_FIELD,
    payload: id
});


export const updateFormField = (id, property, value) => ({
    type: EDITOR_UPDATE_FIELD,
    payload: { id, property, value }
});

export const changeFieldComponent = (id, newComponent) => {
    return (dispatch, getState) => {
        const { formEditor: { form: { jsonSchema: { fields }}}} = getState();
        const newFieldDefault = newField(newComponent);
        const mergedField = mergeNewComponent(newFieldDefault, fields, id);
        dispatch({
            type: EDITOR_CHANGE_FIELD_COMPONENT,
            payload: mergedField
        });
    }
};

export const deleteFormField = () => {
    return (dispatch, getState) => {
        const { formEditor } = getState();
        const { selectedField, form: { jsonSchema: { fields } } } = formEditor;
        const selectedFieldIndex = R.findIndex(R.propEq('id', selectedField))(fields);
        const updatedFields = R.reject(R.propEq('id', selectedField), fields);
        const nextSelectedField = findNextField(selectedFieldIndex, fields);
        dispatch({
            type: EDITOR_DELETE_FIELD,
            payload: updatedFields
        });
        dispatch(selectField(nextSelectedField));
    }
};

export const copyFormField = () => {
    return (dispatch, getState) => {
        const { formEditor: { selectedField, form:{ jsonSchema: { fields } } } }= getState();
        const currentField = R.find(R.propEq('id', selectedField))(fields);
        const fieldSettings = R.omit(['id'], currentField);
        const fieldCopy = R.merge(newField(fieldSettings.component), fieldSettings);
        dispatch({
            type: EDITOR_COPY_FIELD,
            payload:  fieldCopy
        })
    }
}

export const saveForm = () => {
    return (dispatch, getState) => {
        const { formEditor: { form }, user: { profile: { userName } } } = getState();
        dispatch(openDialog(dialogsList.saveForm));

        const { urlFormId, jsonSchema } = form;
        return formsManagerAPI.saveForm({ urlFormId, jsonSchema, lastModifiedUserName: userName, userId: form.createdBy.userId })
            .then(() => {
                dispatch({type: EDITOR_SAVE_FORM});
            })
            .finally(() => {
                dispatch(closeDialog(dialogsList.saveForm));
            });
    }
};

export const deleteEditorForm = () => {
    return (dispatch, getState) => {
        const { formEditor: { form } } = getState();
        return deleteForm(form.urlFormId).then(() => {
            dispatch({ type: EDITOR_DELETE_FORM })
            dispatch(clearEditor());
        });
    }
};

export const clearEditor = () => ({
    type: EDITOR_CLEAR_FORM
});
